import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App.js';
import registerServiceWorker from './registerServiceWorker';
import './scss/styles.scss'

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>, 
  document.getElementById('beaconEnglish')
);
registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js